import { render, staticRenderFns } from "./SignupCredentialsForm.vue?vue&type=template&id=6159b0ee&scoped=true"
import script from "./SignupCredentialsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupCredentialsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SignupCredentialsForm.vue?vue&type=style&index=0&id=6159b0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6159b0ee",
  null
  
)

export default component.exports